import axios from 'axios'
import laroute from '~/laroute'
import User from '~/_shared/models/User'
import { HR_API_URL } from '~/_shared/consts'

// state
export const state = {
  users: [],
  groupNames: [],
  positions: [],
  total: 0,

  // selected user
  user: User,
  hrInfo: {
    hire_date: null,
    actual_first_day: null
  },
  userPermissions: [],

  salesRepsList: []
}

// getters
export const getters = {
  users: state => state.users,
  total: state => state.total,
  groupNames: state => state.positions,
  positions: state => state.positions,

  // selected user
  user: state => state.user,
  userPermissions: state => state.userPermissions,
  salesRepsList: state => state.salesRepsList,
  hrInfo: state => state.hrInfo
}

// mutations
export const mutations = {
  SET_USERS (state, data) {
    state.users = data
  },

  SET_TOTAL (state, data) {
    state.total = data
  },

  SET_GROUP_NAMES (state, data) {
    state.groupNames = data
  },

  SET_POSITIONS (state, data) {
    state.positions = data
  },

  // selected user
  SET_USER (state, data) {
    state.user = data
  },
  SET_USER_PERMISSIONS (state, data) {
    state.userPermissions = data
  },

  // create user
  PUSH_USER (state, data) {
    state.users.push(data)
  },

  SALES_REPS (state, data) {
    state.salesRepsList = data
  },

  HR_INFO (state, data) {
    state.hrInfo = data
  }

}

// actions
export const actions = {
  async fetchUsers ({ commit }, filters) {
    const response = (filters === undefined)
      ? await axios.get(laroute.route('all_users'))
      : await axios.get(laroute.route('all_users', filters))
    commit('SET_USERS', response.data.items)
    commit('SET_TOTAL', response.data.total)
  },
  async fetchPositions ({ commit }) {
    const response = await axios.get(laroute.route('user_group_names'))
    commit('SET_GROUP_NAMES', response.data)
  },
  async fetchPreparedPositions ({ commit }) {
    const response = await axios.get(laroute.route('user_positions'))
    commit('SET_POSITIONS', response.data)
  },

  // selected user
  async fetchUser ({ commit }, userId) {
    const response = await axios.get(`/api/user/${userId}`)
    commit('SET_USER', response.data)
  },

  async fetchHrInfo ({ commit }, userId) {
    const proxyurl = 'https://cors-anywhere.herokuapp.com/'
    if (userId) {
      await axios.get(
        proxyurl + HR_API_URL + 'user-information/?id=' + userId
      )
        .then((res) => {
          if (res.data.hasOwnProperty('success') && res.data.success === true) {
            commit('HR_INFO', res.data.data)
          }
        })
    }
  },

  async fetchUserPermissionsInfo ({ commit }, userId) {
    const response = await axios.get(laroute.route('user_permissions', { userId: userId }))
    commit('SET_USER_PERMISSIONS', response.data)
  },

  async edit ({ commit }, data) {
    const response = await axios.patch(laroute.route('user_edit', { id: data.userId }), {
      position: data.position,
      username: data.username,
      email: data.email,
      first_name: data.first_name,
      last_name: data.last_name,
      unencrypted_password: data.unencrypted_password,
      employee_id: data.employee_id,
      is_active: data.is_active
    })
    commit('SET_USER', response.data)
  },

  async createUser ({ commit }, data) {
    let permissions = {}
    for (let permission of data.permissions) {
      permissions[permission[0]] = permission[1]
    }
    const response = await axios.post(laroute.route('user_create'), {
      userData: data.userData,
      position: data.userData.position,
      permissions: permissions
    })
    commit('PUSH_USER', response.data)
  },

  async fetchSalesReps ({ commit }) {
    const { data } = await axios.get(laroute.route('app_users_initials'))
    commit('SALES_REPS', data)
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/users.js